import { Intersect } from '@openx/types/targeting/targetingValuesTypes.ts';
import type { JSX } from 'react';
import { ColumnKey } from '../../constants.ts';
import {
  StyledAddIcon,
  StyledIconContainer,
  StyledRemoveIcon,
  StyledRowContainer,
} from '../styled/StyledComponents.tsx';
import { TextCellContainer } from './TextCellContainer.tsx';

export const DeviceTypeCellContainer = ({ device_type }): JSX.Element | null => {
  const isAddIcon = device_type.op === Intersect.INTERSECTS;
  const Icon = isAddIcon ? StyledAddIcon : StyledRemoveIcon;

  return (
    <StyledRowContainer container>
      {device_type?.name && (
        <StyledIconContainer>
          <Icon fontSize="small" />
        </StyledIconContainer>
      )}

      <TextCellContainer displayValue={device_type.name} type={ColumnKey.DEVICE_TYPE} />
    </StyledRowContainer>
  );
};
